module.exports = __webpack_public_path__ + "static/media/08.bddd7b1d.jpg";